import { render } from "./ChartAnalysisFree.vue?vue&type=template&id=705f60a4&scoped=true"
import script from "./ChartAnalysisFree.vue?vue&type=script&lang=js"
export * from "./ChartAnalysisFree.vue?vue&type=script&lang=js"

import "./ChartAnalysisFree.vue?vue&type=style&index=0&id=705f60a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705f60a4"]])

export default __exports__